<template>
  <transition name="fade" mode="out-in">
    <div class="app c-app flex-row align-items-center">

      <CContainer class="container-fluid h-100">
        <CCol md="12">
          <CCard
            bodyWrapper
            class="h-100 justify-content-center align-items-center base"
          >
            <CRow style="padding-top: 5rem; padding-bottom: 7rem">
              <div
                class="col-md-12"
                style="align-content: center; text-align: center"
              >
                <LoaderRoller class="mb-4" />

                <h1 class="text-white mr-4">Procesando la respuesta</h1>
              </div>
            </CRow>
          </CCard>
        </CCol>

      </CContainer>


    </div>
  </transition>

</template>

<script>
// import LayoutDefault from '@/app/shared/components/layouts/LayoutDefault'
import LoaderRoller from "@/app/shared/components/LoaderRoller";
import  { TPV_RESPONSE_TYPES } from '@/config';

export default {
  components: {
    LoaderRoller
    // LayoutDefault
  },

  data() {
    return {
      Ds_MerchantParameters: false,
      orderType: null,
      TPV_RESPONSE_TYPES: TPV_RESPONSE_TYPES,
    };
  },

  computed: {
    amount: function () {
      let price = this.Ds_MerchantParameters.Ds_Amount;
      let amount_main = price.substring(0, price.length - 2);
      let amount_dec = price.substring(price.length - 2, price.length);

      return `${amount_main}.${amount_dec}`;
    },
  },

  mounted() {
    this.$nextTick(async () => {

      // if (this.$route.query.r){
        this.orderType = this.$route.query.r;
        this.returnTo();
      // }

    });
  },
  methods: {
    returnTo() {
      const URL = this.setRedirecction();
      this.$router.push(URL);
    },

    setRedirecction() {

      // let type = this.orderType;
      // const CODE = type.substring(0, 2);  // split('_')

      if ( !this.orderType ) {
        return "tpv-response?ko=true";
      }

      if (this.orderType.includes(this.TPV_RESPONSE_TYPES.RC)) {
        // return "clientes/credit_card?ko=true";
        return "tpv-response?ko=true";
      }

      if ( this.orderType.includes(this.TPV_RESPONSE_TYPES.MP) ) {
        return "configuracion/metodo-pago?ko=true";
      }

      if ( this.orderType.includes(this.TPV_RESPONSE_TYPES.CP) ) {
        // return "configuracion/mi-cuenta?ok=true";
        return "parkings?ko=true";
      }

      if ( this.orderType.includes(this.TPV_RESPONSE_TYPES.PC) || this.orderType.includes('null')) {
        return "tpv-response?ko=true";
      }

      if ( this.orderType.includes(this.TPV_RESPONSE_TYPES.PE)) {
        return "tpv-response?ko=true";
      }

      /**

        from=MP / RC / CP 

        RC - registro cliente
        MP - método de pago
        CP - Contratar producto. nueva tarjeta en form contratación
        'PC' => 'PC000', // pay Custom
        'PE' => 'PE000', // pay extra
        
      */

    },

  },
};
</script>

<style lang="scss" scoped>
.base {
  background: rgb(61, 173, 168);
  background: linear-gradient(
    90deg,
    rgba(61, 173, 168, 1) 35%,
    rgba(0, 212, 255, 1) 100%
  );
}

.app {
  width: 100%;
  background-image: url("~@/assets/img/login-background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  // margin-top: $header;
  position: relative;

  @media (min-width: 768px) {
    min-height: 100vh;
  }

  & > * {
    z-index: 2;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.77);  // 0.87
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0.9;
  }

}

</style>
